export const SET_ERROR = 'SET_ERROR';

export default function (value) {
    return {
        type: SET_ERROR,
        value,
    };
}